import React, { Fragment, useState } from "react";
import LeftSidebar from "../../components/layouts/dashboard/Sidebars/leftSidebar/LeftSidebar";
import RightSidebar from "../../components/layouts/dashboard/Sidebars/rightSidebar/RightSidebar";
import HomeDash from "../../components/layouts/dashboard/homeDash/Index";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Card } from "@mui/material";
import { SessionProvider } from "../../contexts/SessionContext";
import useFetch from "../../hooks/useFetch";
function Dashboard() {

  const { Id } = useParams();

  const { pathname } = useLocation()
  return (
    <SessionProvider>
      <div className="dashboard text-md flex min-h-screen">
        <RightSidebar />
        {/* flex-1 + min-w-0 is what makes this track the sidebar: the aside is
            shrink-0 at 7.2rem or 26rem, and main takes whatever is left. It only
            started working once .container came off - that class caps width at
            1090px with !important (styles/abstract/_utility.scss), which the
            landing page wants and the dashboard does not.

            pt on mobile clears the now-fixed menu button. */}
        <main className="main-wrapper h-auto min-w-0 flex-1 px-2xl pt-[6rem] max-md:px-lg md:pt-xl">
          <Outlet />
        </main>
        {/* Only on a class page, where it is the session/section picker that
            feeds contentId + contentInfo to the video player. Everywhere else
            it was just promo cards, so it no longer renders. */}
        {pathname === `/dashboard/classes/${Id}` && <LeftSidebar session />}
      </div>
    </SessionProvider>
  );
}

export default Dashboard;
